module.exports = __webpack_public_path__ + "img/xpr.a9c7312d.svg";